import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PreguntaService {
  private httpPublicClient: HttpClient;

  constructor(
    private httpClient: HttpClient,
    private HttpBackend: HttpBackend
  ) {
    this.httpPublicClient = new HttpClient(HttpBackend);
  }

  getActivasByTema(temaId: number) {
    return this.httpClient.get(
      encodeURI(
        `${environment.apiURL}/preguntas/activasByTema?temaId=${temaId}`
      )
    );
  }

  getActivasByTemaPublic(temaId: number) {
    return this.httpPublicClient.get(
      encodeURI(`${environment.apiURL}/public/preguntasByTema?temaId=${temaId}`)
    );
  }

  getRelacionadas(preguntaId: number) {
    return this.httpClient.get(
      encodeURI(
        `${environment.apiURL}/preguntas/relacionadas?preguntaId=${preguntaId}`
      )
    );
  }

  getRelacionadasPublic(preguntaId: number) {
    return this.httpPublicClient.get(
      encodeURI(
        `${environment.apiURL}/public/relacionadas?preguntaId=${preguntaId}`
      )
    );
  }

  getPreguntaRespuesta(preguntaId: number) {
    return this.httpClient.get(
      encodeURI(
        `${environment.apiURL}/preguntas/preguntaRespuesta?preguntaId=${preguntaId}`
      )
    );
  }

  getPreguntaRespuestaPublic(preguntaId: number) {
    return this.httpPublicClient.get(
      encodeURI(
        `${environment.apiURL}/public/preguntaRespuesta?preguntaId=${preguntaId}`
      )
    );
  }

  getPreguntaById(preguntaId: number) {
    return this.httpClient.get(
      encodeURI(`${environment.apiURL}/preguntas/${preguntaId}`)
    );
  }

  getPrivacidadPreguntasByTema(temaId: number) {
    return this.httpPublicClient.get(
      encodeURI(
        `${environment.apiURL}/public/sonTodasPrivadas?temaId=${temaId}`
      )
    );
  }

  getPrivacidadPregunta(preguntaId: number) {
    return this.httpPublicClient.get(
      encodeURI(
        `${environment.apiURL}/public/privacidad?preguntaId=${preguntaId}`
      )
    );
  }

  crearPregunta(pregunta: { enunciado: string; tema: string }) {
    const formData = new FormData();
    formData.append('enunciado', pregunta.enunciado);
    formData.append('temaId', pregunta.tema);

    return this.httpClient.post(
      encodeURI(`${environment.apiURL}/preguntas`),
      formData
    );
  }

  modificarPregunta(preguntaId, pregunta: { enunciado: string; tema: string }) {
    const formData = new FormData();
    formData.append('enunciado', pregunta.enunciado.trim());
    formData.append('temaId', pregunta.tema);

    return this.httpClient.put(
      encodeURI(`${environment.apiURL}/preguntas/${preguntaId}`),
      formData
    );
  }

  eliminarPregunta(preguntaId: number) {
    return this.httpClient.delete(
      encodeURI(`${environment.apiURL}/preguntas/${preguntaId}`)
    );
  }

  cambiarOrden(preguntas: any) {
    return this.httpClient.put(
      encodeURI(`${environment.apiURL}/preguntas/cambiarOrden`),
      preguntas
    );
  }

  GuardarPublico(resp: { EsPublico: string; preguntaId: string }) {
    const formData = new FormData();

    formData.append('EsPublico', resp.EsPublico);
    formData.append('preguntaId', resp.preguntaId);

    return this.httpClient.post(
      encodeURI(`${environment.apiURL}/preguntas/guardarPublico`),
      formData
    );
  }

  guardarRespuesta(resp: { Textorta: string; preguntaId: string }) {
    const formData = new FormData();

    if (resp.Textorta) {
      formData.append('Textorta', resp.Textorta);
    } else {
      formData.append('Textorta', '');
    }
    formData.append('preguntaId', resp.preguntaId);

    return this.httpClient.post(
      encodeURI(`${environment.apiURL}/preguntas/guardarRespuesta`),
      formData
    );
  }
}
